import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { DesktopNav, MobileNav } from "./Nav";

function useScrolled(threshold = 12) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > threshold);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);
  return scrolled;
}

export default function Header() {
  const [open, setOpen] = useState(false);
  const scrolled = useScrolled();
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 border-b border-ink-700 transition-colors duration-200 ${
        scrolled ? "bg-[#050814]/85 backdrop-blur-xl" : "bg-[#050814]/40 backdrop-blur-md"
      }`}
    >
      <div className="section-padding flex items-center justify-between h-16 lg:h-20">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3 group">
          <div className="flex flex-col leading-tight">
          <span
  className="font-display font-black text-sm sm:text-lg lg:text-3xl tracking-tight"
  style={{
    color: "var(--signal-amber)",
    textShadow: "0 0 15px rgba(255,165,0,.3)"
  }}
>
  CEATECH LABS PVT LTD
</span>
           
          </div>
        </Link>

        <DesktopNav />

        <div className="flex items-center gap-3">
          <Link to="/enquiry" data-testid="header-cta" className="hidden md:inline-flex btn-primary">
            Request quote <ArrowUpRight size={14} />
          </Link>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden p-2 border border-ink-700 hover:border-signal-amber transition-colors"
            aria-label="Toggle menu"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <MobileNav
          onCta={
            <Link to="/enquiry" className="btn-primary mt-4 justify-center" data-testid="mobile-cta">
              Request quote <ArrowUpRight size={14} />
            </Link>
          }
        />
      )}
    </header>
  );
}
